'use strict';

// 
// Class for making an element stick when it reaches the top of the screen.
// 

var _ = require('underscore');
var $ = require('./functions');

// 
// Initial instance.
var ScrollNStick = function( el ) {
	this.el = el;
	this.stuck = false;
	this.unstickAt = null;
	this.sticky = el.dataset.sticky || 'top';

	// Listen to scroll event on window object.
	$.addEventListener( window, 'scroll', _.bind( this.scroll, this ) );
}

// 
// When scrolling see if we should stick/unstick (fix/unfix) the element.
ScrollNStick.prototype.scroll = function() {
	var scrollY = window.scrollY;
	var elY = $.getOffset(this.el).top;

	if ( this.isNotStuck() && scrollY >= elY ) {
		this.stick();
		this.unstickAt = elY;
	}

	else if ( this.isStuck() && scrollY < this.unstickAt ) {
		this.unstick();
	}

}

// 
// Is the element already stuck (fixed)?.
ScrollNStick.prototype.isStuck = function() {
	return this.stuck;
}

// 
// Stick (fix) the element.
ScrollNStick.prototype.isNotStuck = function() {
	return ! this.stuck;
}

// 
// Stick (fix) the element.
ScrollNStick.prototype.stick = function() {
	this.stuck = true;
	this.el.style.position = 'fixed';
	document.getElementsByTagName('html')[0].style['margin-'+this.sticky] = this.el.offsetHeight +'px';
}

// 
// Unstick (fix) the element.
ScrollNStick.prototype.unstick = function() {
	this.stuck = false;
	this.el.style.position = 'relative';
	document.getElementsByTagName('html')[0].style['margin-'+this.sticky] = 0;
}

// Export the module.
module.exports = ScrollNStick;
